import { FC } from 'react';
import styled from 'styled-components';
import { TABLE_COLUMN_WIDTHS, ORDERED_TABLE_COLUMNS } from '../constants';

const TableWrapper = styled.div`
  display: grid;
  grid-template-columns: ${() =>
    ORDERED_TABLE_COLUMNS.map((id) => `[col-${id}] ${TABLE_COLUMN_WIDTHS[id]}`).join(' ')};
  align-items: stretch;
  font-family: 'Sofia Pro', system-ui, -apple-system, BlinkMacSystemFont, 'Avenir Next', Avenir,
    'Segoe UI', 'Lucida Grande', 'Helvetica Neue', Helvetica, 'Fira Sans', Roboto, Noto,
    'Droid Sans', Cantarell, Oxygen, Ubuntu, 'Franklin Gothic Medium', 'Century Gothic',
    'Liberation Sans', sans-serif;
  margin: -${({ theme }) => theme.spacing.values.threeQuarter} -${({ theme }) =>
    theme.spacing.values.plusHalf};
`;

export const Table: FC<React.PropsWithChildren<unknown>> = ({ children }) => (
  <TableWrapper data-test="list-usage-table">{children}</TableWrapper>
);
